import axios from './axios'
const wx = window.wx
/**
 * { title, path, desc, imgUrl, callback }
*/

export const wechat = async (options) => {
  // 非生产环境跳出
  if (process.env.VUE_APP_CURRENTMODE !== 'prod') {
    return false
  }
  const { origin } = window.location
  const shareRoutes = ['productDetails', 'flingOrder']
  const user = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
  const uid = user.share_code ? user.share_code : 'isShare'
  const defaults = {
    title: '云南联通PLUS权益商城',
    link: `https://v2.5gynmall.com/home?channel=${uid}`,
    desc: '云南联通PLUS会员，丰富的权益帮您一省到底！',
    imgUrl: require('../assets/img/favicon.png')
  }
  const { name } = options
  if (options && shareRoutes.includes(name)) {
    Object.assign(defaults, options)
  } else {
    Object.assign(options, defaults)
    // options = defaults
  }
  // console.log(options, defaults, name)
  const { title, desc, imgUrl, callback, fullPath } = options
  const url = `${origin}${fullPath}`
  const link = shareRoutes.includes(name) ? `${url}&channel=${uid}` : options.link
  const res = await axios({
    url: 'api/public/jssdk/config',
    method: 'get',
    baseURL: 'https://v2.5gynmall.com/5gadmin/',
    // baseURL: process.env.VUE_APP_LOCAL_BASE_URL,
    params: {
      url: url
    }
  })
  const { data, error } = res.data
  if (error === 0) {
    const { appId, timestamp, nonceStr, signature } = data
    await wx.config({
      debug: false,
      appId,
      timestamp,
      nonceStr,
      signature,
      jsApiList: [
        /* 'updateAppMessageShareData',
        'updateTimelineShareData' */
      ],
      openTagList: ['wx-open-launch-weapp']
    })
  }
  await wx.ready(() => {
    wx.updateAppMessageShareData({
      title,
      link,
      desc,
      imgUrl,
      success: res => {
        callback()
      }
    })
    wx.updateTimelineShareData({
      title,
      link,
      imgUrl,
      success: (res) => {
        callback()
      }
    })
  })
}
